import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
// import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { getVehicleAllotmentReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";

const VehicleAllotmentReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/vehicleallotmentreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/vehicleallotmentreportform",
    PRINT_ACCESS
  );

  const TourDateCode = params?.TourDateCode;
  const loading = useAppSelector((state) => state.reports.loading);
  const VehicleAllotmentReport = useAppSelector(
    (state) => state.reports.VehicleAllotmentReport
  );

  useEffect(() => {
    if (TourDateCode) {
      const payload = {
        TourDateCode: TourDateCode ?? null,
      };
      dispatch(getVehicleAllotmentReport(payload));
    }
  }, []);

  let totalNights = 0;

  VehicleAllotmentReport &&
    VehicleAllotmentReport.length > 0 &&
    VehicleAllotmentReport?.forEach((report: any) => {
      totalNights += +report.NoOfNights || 0;
    });

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "VehicleAllotmentReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "vehicleallotmentreport.xlsx");
  };

  const printTable = () => {
    let table = document.querySelector(
      ".table-bordered"
    ) as HTMLTableElement | null;
    let printbuttons = document.querySelector(".printbuttons") as any;
    let report_container = document.querySelector(".report-container") as any;
    if (!table) {
      console.error("Table element not found.");
      return;
    }

    printbuttons.style.display = "none";
    report_container.style.padding = "20px 0";
    let tableRows = table.rows.length;
    let maxRows = table.rows.length;
    let pageCount = Math.ceil(tableRows / maxRows);
    let printContent = document.createElement("div");
    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      //   content += "<h2>Page " + (i + 1) + "</h2>";
      content += '<table class="table table-bordered reportScreens">';

      let startRow = i * maxRows;
      let endRow = Math.min((i + 1) * maxRows, tableRows);

      for (let j = startRow; j < endRow; j++) {
        content += table.rows[j].outerHTML;
      }

      content += "</table>";
      content += "</div>";
    }

    printContent.innerHTML = content;
    table.style.display = "none";
    document.body.appendChild(printContent);

    const style = document.createElement("style");
    style.textContent = `@page { margin: 1cm; }`;
    document.head.appendChild(style);

    window.print();
    printContent.remove();
    table.style.display = "table";
    printbuttons.style.display = "block";
    report_container.style.padding = "20px 10px";
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Vehicle Allotment Report
          <span style={{ fontSize: 15 }}>
            {" "}
            (Tour Date Code : {TourDateCode} )
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={printTable}
            >
              Print
            </Button>
          )}
          {isExcelExportAccess && (
            <Button
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={handleExportExcel}
            >
              Excel Export
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive" style={{ margin: "0 10px" }}>
        <table className="table table-bordered reportScreens">
          <thead>
            <tr>
              <th style={{ background: "black", color: "white" , width:50  }}>No</th>
              <th style={{ background: "black", color: "white",  width:150  }}>
                Tour Booking NO
              </th>
              <th style={{ background: "black", color: "white" }}>Name</th>
              <th style={{ background: "black", color: "white" }}>Mobile No</th>
              <th style={{ background: "black", color: "white" }}>Age</th>
              <th style={{ background: "black", color: "white" }}>Gender</th>
              <th style={{ background: "black", color: "white" }}>
                Hotel Voucher No
              </th>
              <th style={{ background: "black", color: "white" }}>
                Route Voucher No
              </th>
              <th style={{ background: "black", color: "white" }}>
                No Of Nights
              </th>
              <th style={{ background: "black", color: "white" , width:200 }}>Remark</th>
            </tr>
          </thead>
          <tbody>
            {VehicleAllotmentReport &&
              VehicleAllotmentReport.length > 0 &&
              VehicleAllotmentReport?.map((report: any, index: number) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{report?.TourBookingNO}</td>
                  <td>{report?.Name}</td>
                  <td>{report?.MobileNo}</td>
                  <td>{report?.Age}</td>
                  <td>{report?.Gender}</td>
                  <td>{report?.HotelVoucherNo}</td>
                  <td>{report?.RouteVoucherNo}</td>
                  <td>{report?.NoOfNights || 0}</td>
                  <td>{report?.Remarks}</td>
                </tr>
              ))}
            <tr className="fw-bold">
              <td
                colSpan={8}
                className="text-end pe-5"
                style={{ background: "lightgray", color: "black" }}
              >
                Total
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalNights}
              </td>
              <td style={{ background: "lightgray", color: "black" }}></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default VehicleAllotmentReportView;
